import { useI18n, LivingSpaceIcon } from '@popety_io/popety-io-lib'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { Divider } from '@mui/material'

const EstimateLandSummaryHeader = ({ data }: { data: Record<string, any> }) => {
  const { t } = useI18n()

  return (
    <>
      <Box
        position="sticky"
        top={0}
        pt={2}
        zIndex={10}
        bgcolor="background.paper"
      >
        <Typography
          variant="h2"
          sx={{
            marginBottom: '4px',
            textTransform: 'uppercase',
          }}
          fontSize="1.7rem"
          fontWeight={500}
        >
          {t('common.landRadarInfo.parcelle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#969696',
            paddingBottom: '10px',
          }}
          fontSize="1rem"
        >
          {t('common.land.header_description')}
        </Typography>
        <Divider />
      </Box>

      <Box pt={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <LivingSpaceIcon color="primary" />
              </Grid>
              <Grid item xs={10}>
                <Box>
                  <Typography
                    variant="h3"
                    fontSize="2.5rem"
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                    }}
                    fontWeight={600}
                  >
                    {data.area} m2
                  </Typography>
                  <Typography
                    fontSize="1rem"
                    sx={{
                      color: '#969696',
                    }}
                    fontWeight={500}
                  >
                    {t('financial.Surface de la parcelle')}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={4} />
          <Grid item xs={12} sm={6} md={4} />
        </Grid>
      </Box>
    </>
  )
}

export default EstimateLandSummaryHeader
